import * as I from "immutable";

import { Action, actionCreators } from "../actions";

type Status = "pending" | { state: "loaded"; height: number; width: number } | undefined;

const initialStore = I.Record({
    loadedUrl: I.Map<string, Status>(),
})();
type Store = typeof initialStore;

export function update(store = initialStore, action: Action): Store {
    switch (action.type) {
        case actionCreators.loadAvatarStarted.type: {
            let { loadedUrl } = store;
            loadedUrl = loadedUrl.set(action.url, "pending");
            return store.set("loadedUrl", loadedUrl);
        }
        case actionCreators.loadAvatarSuccess.type: {
            let { loadedUrl } = store;
            const { url, height, width } = action;
            loadedUrl = loadedUrl.set(url, { state: "loaded", height, width });
            return store.set("loadedUrl", loadedUrl);
        }
        case actionCreators.loadAvatarFailure.type: {
            let { loadedUrl } = store;
            loadedUrl = loadedUrl.delete(action.url);
            return store.set("loadedUrl", loadedUrl);
        }

        default: {
            return store;
        }
    }
}

export type OuterStore = { avatars: Store };

export function isLoaded(store: OuterStore, avatarUrl: string | undefined) {
    if (avatarUrl) {
        return store.avatars.loadedUrl.get(avatarUrl);
    }
    return;
}
